import axios from '@/util/axios';
import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/sys/role/list',params);
    },

    add(params) {
        return common.post('/rocheManage/sys/role/add',params);
    },

    edit(params) {
        return common.put('/rocheManage/sys/role/edit',params);
    },

    delete(params) {
        return common.delete('/rocheManage/sys/role/delete',params);
    },

    deleteBatch(params) {
        return common.delete('/rocheManage/sys/role/deleteBatch',params);
    },
    
    queryRolePrivilege(params) {
        return common.get('/rocheManage/sys/permission/queryRolePermission',params);
    },
    
    saveRolePrivilege(params) {
        return common.post('/rocheManage/sys/permission/saveRolePermission',params);
    },
}



// WEBPACK FOOTER //
// ./src/api/sysmanagement/role.js